import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import useDeleteWorkoutBenchmark from 'hooks/workoutBenchmark/useDeleteWorkoutBenchmark';
import { WorkoutMovementList } from 'types';
import notificationHandler from 'utils/notifications';

const ModalBenchmarkDelete = ({
  opened,
  benchmark,
  handleClose,
}: {
  opened: boolean;
  handleClose: () => void;
  benchmark: WorkoutMovementList;
}): JSX.Element => {
  const { mutate, isLoading } = useDeleteWorkoutBenchmark();
  const { successNotification, errorNotification } = notificationHandler();

  const handleDelete = (): void => {
    mutate(benchmark.workoutMovementId, {
      onSuccess: () => {
        successNotification('Benchmark deleted', `${benchmark.name} has been removed from the library.`);
      },
      onError: error => {
        const errorMessage = error.response?.data?.message || 'Failed to delete benchmark';
        errorNotification('Delete failed', errorMessage);
      },
      onSettled: () => {
        handleClose();
      },
    });
  };

  return (
    <Modal
      centered
      opened={opened}
      onClose={handleClose}
      title={<Title order={4}>Delete Benchmark?</Title>}
      size='auto'
    >
      <Stack>
        <Text>
          Are you sure you want to remove <strong>{benchmark.name}</strong> from your Benchmarks library?
        </Text>
        <Text color='dimmed'>Any results athletes have already logged against it are preserved.</Text>
        <Group position='right'>
          <Button variant='subtle' onClick={handleClose}>
            Cancel
          </Button>
          <Button onClick={handleDelete} color='red' loading={isLoading}>
            Delete
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalBenchmarkDelete;
